export class MailActionReplyParams {
  public statut?: string;
  public reponse?: string;
  public commentaires?: string;
  public validated: boolean; // Indicates wether the response is validated and will be marked as treated.If False, we will only update Reponse and Statut fields.
  public suiviReponseMessage?: string; // Si le champ AccuseReponse / SuiviDeReponse est à 1, alors il faut envoyer « Réponse de xxxxx » où xxxxx = nom de la personne qui a répondu
  public replacementContactId?: number;

  public reponseData?: {
    value: boolean | string | number;
    Properties?: {
      key: string;
      value: unknown;
    };
  };
}
